import { render, staticRenderFns } from "./vList.vue?vue&type=template&id=46d90e02&"
import script from "./vList.vue?vue&type=script&lang=js&"
export * from "./vList.vue?vue&type=script&lang=js&"
import style0 from "./vList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports